import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'

export const AnchorIcon: FC<IconProps> = ({ width = 19, height = 20, ...rest }) => (
  <Icon type="Anchor" width={width} height={height} alt="anchor" {...rest} />
)
